/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tool_Risk_Low_HintInputs */



/**
* | output |
* | --- |
* | "Reads data only. It cannot change anything." |
*
* @param {Tool_Risk_Low_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tool_risk_low_hint = /** @type {((inputs?: Tool_Risk_Low_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tool_Risk_Low_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Liest nur Daten. Es kann nichts verändern.")
	return /** @type {LocalizedString} */ ("Reads data only. It cannot change anything.")
});